import { defineMessages } from "react-intl";

const messages = defineMessages({
    jobTitle: {
        description: "Label for job title input",
        defaultMessage: "Job title"
    },
    jobTitlePlaceholder: {
        description: "Placeholder for job title input",
        defaultMessage: "e.g. Developer"
    }
});

export default messages;
